import { useState } from "react";

function useProvideAuth() {
  const [user, setUser] = useState(localStorage.getItem('token'));
  const [userName, setUserName] = useState(localStorage.getItem('name'))
  const [picture, setPicture] = useState(localStorage.getItem('picture'));

  // *User
  const userLogin = (data) => {
    console.log("🚀 ~ file: useProvideAuth.js:9 ~ userLogin ~ data:", data)
    localStorage.setItem('token', data.token)
    localStorage.setItem('name', data.name)
    localStorage.setItem('picture', data.picture)
    setUser(data.token)
    setUserName(data.name)
  };

  const userLogout = async () => {
    setUser(null)
    localStorage.clear()
  };

  // *Verify Token
  const verifyToken = () => {
    const token = localStorage.getItem('token')
    const name = localStorage.getItem('name')
    setUser(token)
    setUserName(name)
  };

  return {
    user,
    userName,
    userLogin,
    userLogout,
    verifyToken
  };
}

export default useProvideAuth;